// import { Flex } from "@chakra-ui/react";
// import { useOverlay } from "@toss/use-overlay";
import {
  Button,
  ColorIcon,
  colors,
  customEvent,
  // call,
  FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  // useResponsive,
  HackleEventName,
  HStack,
  useResponsive,
  VStack,
} from "goi_common";
import { ParlorDetailProps } from "@/types/parlor";
import { useState } from "react";
// import FileRequestModal from "./Modal/FileRequestModal";
import ParlorCompareModal from "./ParlorCompareModal";
import { useRouter } from "next/router";
import { Box, Flex } from "@chakra-ui/react";
import { safeParlorIds } from "@/constants/parlor/excludeParlors";
import ExperimentFileRequestModal from "@/components/Modal/ExperimentFileRequestModal";
import { useOverlay } from "@toss/use-overlay";
import ParlorVisitedListSlot from "./ParlorVisitedListSlot";
import { useParlorInquiryModal } from "@/hooks/useParlorInquiryModal";

const ParlorFixedButtons = ({
  parlor,
  selectedSangjo,
  closestParlors,
}: {
  parlor: ParlorDetailProps;
  selectedSangjo: string;
  closestParlors: any;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isBiggerThanMd } = useResponsive();
  const overlay = useOverlay();

  const router = useRouter();

  const { openParlorInquiryModal } = useParlorInquiryModal("parlor_detail");

  const 시도 = FUNERAL_SIDO.get(Number(parlor.sido));
  const 시군구 = FUNERAL_SIGUNGU.get(Number(parlor.sido))?.get(Number(parlor.sigungu));
  const regionLabel = [시도, 시군구].filter(Boolean).join(" ");

  return (
    <>
      {!safeParlorIds.includes(Number(parlor.id)) && (
        <VStack
          alignItems="center"
          position="fixed"
          style={{
            bottom: 70,
            right: 18,
          }}
          zIndex={5}
        >
          <VStack width="100%" alignItems="center" maxWidth="480px">
            {/* <VStack width="100%" maxWidth="480px">
          <Flex width="100%" alignItems="flex-end" justifyContent="end" pb="12px" pr="20px">
            <HStack
              width="300px"
              borderRadius="6px"
              boxShadow="0px 4px 12px rgba(0, 0, 0, 0.5)"
              height="40px"
              className="caption_12_b gray800"
              background="white"
              alignItems="center"
              padding="12px"
              gap={6}
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "parlor_detail",
                    trigger_and_target: "footer_floating-checklist",
                  },
                });
                overlay.open(({ isOpen, close: onClose }) => {
                  return <FileRequestModal isOpen={isOpen} onClose={onClose} />;
                });
              }}
            >
              <div>장례 비용 예상 견적표, 임종 준비 체크리스트 받아보기</div>
              <ColorIcon name="icon-arrow-right-circle-mono" size={14} color={colors.gray700} />
            </HStack>
          </Flex>
        </VStack> */}

            <VStack width="100%" alignItems="center" zIndex={5}>
              <ParlorVisitedListSlot parlor={parlor} region={regionLabel}>
                <HStack
                  width="100%"
                  maxWidth="480px"
                  height={"48px"}
                  css={{
                    margin: 0,
                    height: 48,
                    bottom: isBiggerThanMd ? 0 : 0,
                    cursor: "pointer",
                  }}
                  background="white"
                  borderRadius="48px"
                  padding="12px 16px"
                  alignItems="center"
                  boxShadow="0px 0px 4px rgba(0, 0, 0, 0.5)"
                  onClick={() => {
                    customEvent({
                      newGtm: {
                        path: "parlor_detail",
                        trigger_and_target: "footer_floating-checklist",
                      },
                    });
                    overlay.open(({ isOpen, close: onClose }) => {
                      return (
                        <ExperimentFileRequestModal
                          expPage="parlor"
                          path="parlor_detail"
                          isOpen={isOpen}
                          onClose={onClose}
                        />
                      );
                    });
                  }}
                >
                  <Box className="caption_12_b">
                    장례 비용 예상 견적표, 임종 준비 체크리스트 받아보기
                    <br />- 고이장례연구소
                  </Box>
                  <ColorIcon name="chevron_right_24" color={colors.gray800} size={36} />
                </HStack>
              </ParlorVisitedListSlot>
            </VStack>
          </VStack>
        </VStack>
      )}
      <VStack
        alignItems="center"
        width="100%"
        position="fixed"
        style={{
          bottom: 0,
        }}
      >
        <VStack width="100%" alignItems="center">
          {safeParlorIds.includes(Number(parlor.id)) && (
            <VStack width="100%" maxWidth="480px">
              <Flex width="100%" alignItems="flex-end" justifyContent="end" pb="12px" pr="20px">
                <ParlorVisitedListSlot parlor={parlor} region={regionLabel}>
                  <HStack
                    width="300px"
                    borderRadius="6px"
                    boxShadow="0px 4px 12px rgba(0, 0, 0, 0.5)"
                    height="40px"
                    className="caption_12_b gray800"
                    background="white"
                    alignItems="center"
                    padding="12px"
                    gap={6}
                    onClick={() => {
                      customEvent({
                        newGtm: {
                          path: "parlor_detail",
                          trigger_and_target: "footer_floating-checklist",
                        },
                      });
                      overlay.open(({ isOpen, close: onClose }) => {
                        return (
                          <ExperimentFileRequestModal
                            expPage="parlor"
                            path="parlor_detail"
                            isOpen={isOpen}
                            onClose={onClose}
                          />
                        );
                      });
                    }}
                  >
                    <div>장례 비용 예상 견적표, 임종 준비 체크리스트 받아보기</div>
                    <ColorIcon
                      name="icon-arrow-right-circle-mono"
                      size={14}
                      color={colors.gray700}
                    />
                  </HStack>
                </ParlorVisitedListSlot>
              </Flex>
            </VStack>
          )}

          <VStack width="100%" background={colors.gray50} alignItems="center">
            <HStack
              width="100%"
              maxWidth="480px"
              height={"64px"}
              css={{
                margin: 0,
                height: 48,
                bottom: isBiggerThanMd ? 0 : 0,
                zIndex: 5,
              }}
            >
              <HStack width="100%" height="100%" padding={"4px 20px 12px"} gap={8}>
                <Button
                  style={{
                    color: "white",
                    width: "50%",
                    height: "100%",
                    backgroundColor: colors.black,
                    borderRadius: "5px",
                  }}
                  className="button"
                  onClick={() => {
                    customEvent({
                      newGtm: {
                        path: "parlor_detail",
                        trigger_and_target: "footer_compare-open_compare_modal",
                      },
                      hackle: { key: HackleEventName["장례식장 상세 푸터 - 비교하기"] },
                    });

                    router.push(`/parlors/region/${시도}-${시군구}`);
                  }}
                >
                  <div className="caption1">{시군구} 장례식장 비용</div>
                  <HStack className="button_14_sb" alignItems="center" justifyContent="center">
                    <div>전체 비교하기</div>
                    <ColorIcon name="icon-arrow-right-small-mono" size={16} color="white" />
                  </HStack>
                </Button>
                <Button
                  style={{
                    color: colors.white,
                    width: "50%",
                    height: "100%",
                    backgroundColor: colors.black,
                    borderRadius: "5px",
                  }}
                  onClick={() => {
                    customEvent({
                      newGtm: {
                        path: "parlor_detail",
                        trigger_and_target: "footer_lft-quickcall_modal",
                      },
                    });

                    // router.push(`/guidebook`);
                    void openParlorInquiryModal();
                    // call("1666-9784");
                    // onQuickCallModal();
                  }}
                  className="button"
                >
                  <VStack alignItems="center" gap={0} justifyContent="center">
                    <div className="caption1">{`${
                      safeParlorIds.includes(Number(parlor.id)) ? "" : "고이 "
                    }24시간 전화상담`}</div>
                    {/* <div className="caption1">장례 준비 가이드</div> */}
                    <HStack
                      className="button_14_sb"
                      alignItems="center"
                      justifyContent="center"
                      gap={6}
                    >
                      <div>임종접수/장례문의</div>

                      {/* <ColorIcon name="icon-call-mono" size={16} color="white" /> */}
                      <ColorIcon
                        name="icon-arrow-right-small-mono"
                        size={16}
                        color={colors.white}
                      />
                    </HStack>
                  </VStack>
                </Button>
              </HStack>
            </HStack>
          </VStack>
        </VStack>
        <ParlorCompareModal
          closestParlors={closestParlors}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          parlor={parlor}
          selectedSangjo={selectedSangjo}
        />
      </VStack>
    </>
  );
};

export default ParlorFixedButtons;
